import type { LucideIcon } from 'lucide-react'
import type { Faq } from '@/types'

import {
    Award,
    CalendarCheck,
    Gem,
    HandHeart,
    Heart,
    MessageCircleHeart,
    Sparkles
} from 'lucide-react'

import { address, contact, hours } from '@/constants/site'

export type Reason = {
    title: string
    text: string
    icon: LucideIcon
}

export const reasons: Reason[] = [
    {
        title: "We care about your skin",
        text: "Every service starts with understanding your skin type, so your skin stays healthy, happy and glowing.",
        icon: HandHeart
    },
    {
        title: "We provide what you want and care about",
        text: "Tell us the look you have in mind. We listen, suggest and create it just the way you want it.",
        icon: Heart
    },
    {
        title: "Only high quality products are used",
        text: "From skin care to makeup, we use only high quality products for safe and beautiful results.",
        icon: Gem
    },
    {
        title: "Experienced make-up and nail artists",
        text: "Experienced professional make-up artist and nail artist are available to create your perfect look.",
        icon: Award
    }
]

export const essentials = [
    "Threading",
    "Waxing",
    "Bleach",
    "De-tan",
    "Manicure",
    "Pedicure"
]

export type Step = {
    title: string
    text: string
    icon: LucideIcon
}

export const bookingSteps: Step[] = [
    {
        title: "Message or call us",
        text: `Tell us the service you want on WhatsApp or call ${contact.phoneDisplay}.`,
        icon: MessageCircleHeart
    },
    {
        title: "Pick your time",
        text: `We are ${hours.days.toLowerCase()}, ${hours.label}. We confirm a slot that suits you.`,
        icon: CalendarCheck
    },
    {
        title: "Relax and glow",
        text: "Visit us in New Gupta Colony and let our artists take care of the rest.",
        icon: Sparkles
    }
]

export const instagramTiles = [
    { label: "Bridal looks", image: '/images/hero-bride.jpg', alt: "Bride in a red lehenga with gold jewellery", className: 'object-[50%_10%]' },
    { label: "Nail art", image: '/images/nail-extensions.jpg', alt: "Pink and gold floral nail art", className: 'object-center' },
    { label: "Party makeovers", image: '/images/makeover.jpg', alt: "Glam party makeup with shimmering eyes", className: 'object-[50%_40%]' },
    { label: "Hair designs", image: '/images/hair-care.jpg', alt: "Textured updo hair design", className: 'object-[50%_25%]' },
    { label: "Trendy nails", image: '/images/nail-art.jpg', alt: "Colourful geometric nail art", className: 'object-center' },
    { label: "Skin and facials", image: '/images/facial-cleanup.jpg', alt: "Relaxing facial cleanup", className: 'object-[55%_50%]' }
]

export const homeFaqs: Faq[] = [
    {
        question: "Where is Anushka Beauty Parlour located?",
        answer: `We are at ${address.full}. The nearest metro station is ${address.nearestMetro}.`
    },
    {
        question: "What are your opening hours?",
        answer: `We are ${hours.days.toLowerCase()}, from ${hours.label}.`
    },
    {
        question: "Is Anushka Beauty Parlour only for women?",
        answer: "Yes. We are a women's beauty parlour, so you can relax in a comfortable and private space."
    },
    {
        question: "How do I book an appointment?",
        answer: `Message us on WhatsApp or call ${contact.phoneDisplay}. Tell us the service and your preferred time and we will confirm your slot.`
    },
    {
        question: "Do you offer HD and airbrush bridal makeup?",
        answer: "Yes. We offer both HD and airbrush bridal makeup, along with bridal hairstyling, dupatta setting, draping and pre-bridal skin care."
    },
    {
        question: "Do you do nail extensions and keratin treatment?",
        answer: "Yes. Our experienced nail artist does designer nail art and nail extensions, and our hair care includes keratin treatment, hair spa, smoothening and rebonding."
    },
    {
        question: "Which areas do you serve?",
        answer: "Women visit us from New Gupta Colony, Model Town, Vijay Nagar, GTB Nagar, Hudson Lane, Kamla Nagar, Roop Nagar, Shakti Nagar and all across North Delhi."
    },
    {
        question: "Where can I see your work?",
        answer: `Follow us on Instagram at ${contact.instagramHandle} to see our makeups, nail arts and hair designs.`
    },
    {
        question: "What are your charges?",
        answer: "Charges depend on the service and the look you choose. Message us on WhatsApp or call us and we will share the details for your requirement."
    }
]
